import { useEffect, useState } from 'react';

import { subscribeToNewVersions } from 'utils/firestore';

import useSnackbar from '@joinforma/ui/hooks/useSnackbar';

const DeployListenerLayout = ({ children }: { children: JSX.Element }) => {
  const { showPlainSnackbar } = useSnackbar();
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const unsubscribe = subscribeToNewVersions(
      'client-web',
      (new_version: number) => {
        if (version && new_version !== version) {
          showPlainSnackbar({
            persist: true,
            text: 'A new version of the app is available. Please click refresh to update to the latest version.',
            actionText: 'Refresh',
            onActionClick: () => window.location.reload(),
          });
        } else {
          setVersion(new_version);
        }
      }
    );

    return () => {
      unsubscribe();
    };
  }, [version, showPlainSnackbar]);

  return children;
};

export default DeployListenerLayout;
